import React, { useEffect, useState } from "react";

import { Container } from "./styles";
import { Card, CardBody, CardFooter, Grid, Link, Section } from "uikit-react";
import { GetApi } from "../../services/auth";
import { MudaVisibilidade } from "../../services/funcoes";
import { Loading } from "../../helpers";
import { ListaMenu } from "../../constants";
import { getProfCliente } from "../../services/auth";
import KPIDashboard from "../../componentes/KPIs";

const perfilCodLocal = localStorage.getItem('perfilAcesso');
const MenuRapido = () => {
  const profissao = getProfCliente();
  const [perfilAdmin, setPerfilAdmin] = useState("");

  useEffect(() => {
    if(perfilCodLocal === null){
      DadosCliente();
    } else {  
      setPerfilAdmin(perfilCodLocal);
    } 
  }, []);

  const DadosCliente = async () => {
      MudaVisibilidade("LoadingPage");
    const response = await GetApi("Cliente/ListarClienteDoc/");

    if(response?.data.sucesso){
      const nome = response.data?.nome ?? 'ADMIN'
      localStorage.setItem('nomeUser', nome);

      const perfilAdmin = response.data?.codigoExterno ?? '';
      localStorage.setItem('perfilAcesso', perfilAdmin);

      setPerfilAdmin(perfilAdmin);
    }
      MudaVisibilidade("LoadingPage");
  };
  
  return (
    <>
      <Container size="expand" className="content-padder content-padder-inative" id="padder">            
        <main className="uk-section">
          <Section className="uk-container uk-container-xlarge uk-margin">   

             <h4 className="uk-text-bold">
                Atalhos
              </h4> 

              {/* <Loading /> */}

            <Grid className="uk-child-width-1-1@s uk-child-width-1-3@m uk-child-width-1-4@xl uk-grid-match">

                {
                  ListaMenu.map((item, index) => (
                    (item.master && profissao !== "6005") ? null :
                    <Section key={index}>
                      <a href={item.link} className="uk-display-block uk-card uk-card-default uk-card-hover uk-card-body uk-link-toggle">
                        <Grid className="uk-flex uk-flex-middle">
                          <Section className="uk-width-expand">
                              <h3 className="uk-card-title uk-text-truncate"> {item.menu} </h3>
                              <p className="uk-text-small"> {item.descricao} </p>
                          </Section>
                          <Section className="uk-width-auto">
                              <span uk-icon={item.icone}></span>
                          </Section>
                        </Grid>
                      </a>
                    </Section>
                  ))
                }

          </Grid>

          </Section>

          <KPIDashboard />

        </main>
      </Container>  
    </>
  );
}

export default MenuRapido;
